import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import * as Colors from './Colors'
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Menu, Group, ChevronLeft, ChevronRight, HelpOutline } from '@material-ui/icons';
import * as Styles from '@material-ui/core/styles';
import { Auth, toInjector } from '../stores';
import { PageProps, withPageProps } from './Page'
import * as HokanApi from '../api/hokan'
import { globalSearch, GlobalSearchResponse } from '../api/search'
import * as Model from '../models'
import PatientNavigation from './PatientNavigation';
import { Badge, Avatar, Tooltip } from '@material-ui/core';
import AvatarStore from '../firebase/AvatarStore'
// import { Spring, animated } from 'react-spring/renderprops'
import { ImageUtil } from '../util/ImageUtil'
import { resolveAttachmentUrl } from '../util/attachment-resource'
import AlertDialog from './AlertDialog';
import ImageSourceDialog from './image-source-dialog';
import { UADetector } from '../util/UAUtil';
import Autocomplete from '@material-ui/lab/Autocomplete';

import TextField from '@material-ui/core/TextField';
const NotificationBell = React.lazy(() => import('./NotificationBell'));

const drawerWidth = 260;


const styles = (theme: any) => ({
    root: {
        display: 'flex',
        backgroundColor: Colors.forthColor,
        '@media print': {
            display: 'none',
        },
    },
    title: {
        fontSize: "0.9rem",
        display: "inline-block"
    },
    appBar: {
        overflow: "visible"
    },
    toolBar: {
        minHeight: "3em",
        maxHeight: "3em",
        marginTop: 4,
        marginRight: 4,
    },
    appBarShift: {
    },
    menuButton: {
        marginLeft: 12,
        marginRight: "5px",
    },
    patientButton: {
        marginRight: 5,
    },
    rightSpacer: {
        marginLeft: "auto",
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        color: Colors.primaryColor
    },
    drawerPaper: {
        width: drawerWidth,
        color: "white",
        backgroundColor: Colors.primaryColor,
        top: 'var(--urgent-banner-height, 0px)',
        height: 'calc(100% - var(--urgent-banner-height, 0px))'
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: '0 12px',
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
        color: "white",
        backgroundColor: Colors.primaryColor
    },
    drawerName: {
        marginBlockEnd: 0,
        fontSize: "1.1rem"
    },
    drawerOffice: {
        marginBlockStart: 0,
        fontSize: "1.0em"
    },
    largeIcon: {
        width: 60,
        height: 60,
        marginTop: "10px",
        marginRight: "10px",
        color: Colors.primaryColor
    },
    drawerIcon: {
    },
    content: {
        flexGrow: 1,
        padding: 10,
    },
    contentShift: {
        marginLeft: 0,
    },
    drawerHeaderInfoBlock: {
        justifyContent: "left",
        paddingTop: "0px",
        width: "100%",
        color: "white"
    },
    drawerHeaderInfoElement: {
    },
    link: {
        textDecoration: 'none',
        color: Colors.primaryColor
    },
    loginHeader: {
        backgroundColor: Colors.primaryColor,
        color: "white",
        width: "100%"
    },
    activity_face: {
        width: "40px",
        height: "40px",
        borderRadius: "50px",
        objectFit: "contain" as any,
        backgroundPosition: "center center",
        backgroundSize: "cover",
        display: "inline-flex",
        cursor: "pointer",
        fontSize: "1rem"
    },
    header_logo: {
        height: "30px"
    },
    item: {
        backgroundColor: Colors.white,
        color: Colors.primaryColor,
        border: "solid",
        borderWidth: "1px",
        borderColor: Colors.primaryColor,
        marginTop: "-1px",
        fontSize: "1.0rem"
    },
    autocomplete_group: {
        lineHeight: "1.2",
        backgroundColor: Colors.primaryColor,
        color: Colors.white,
        position: "sticky" as "sticky",
        top: "-8px",
        padding: "6px 10px",
        zIndex: 1
    },
    autocomplete_ul: {
        margin: "0px",
        padding: "0px"
    },
    badge: {
        height: 14,
        minWidth: 14
    }
});

interface Props extends Auth, Styles.WithStyles<typeof styles>, PageProps {
    theme: any,
    loginMode: boolean
}


interface LocalState {
    open: boolean
    openNow: boolean
    openPatient: boolean
    me: Model.User | null
    notifyCount: number
    avatar_url: string
    avatarDialogOpen: boolean
}

@inject(...toInjector(Auth))
@observer
class HeaderNavigation extends React.Component<Props, LocalState> {
    displayName = "HeaderNavigation"
    constructor(props) {
        super(props)
        this.state = {
            open: false,
            openNow: false,
            openPatient: false,
            me: null,
            notifyCount: 0,
            avatar_url: "",
            avatarDialogOpen: false
        };
    }

    private handleDrawerOpen = () => {
        this.setState({ open: true, openNow: true });
        HokanApi.me()
            .then(x => {
                this.setState({ me: x.data })
            })
            .catch(err => {
                console.log(err);
            })
    };

    private handleDrawerClose = () => {
        this.setState({ open: false });
    };

    private handlePatientOpen = () => {
        this.setState({ openPatient: true });
    }


    private meLoading: boolean = false
    private meRetryTimer: number | null = null
    private unmounted: boolean = false

    public componentDidMount() {
        this.loadMe()
    }

    public componentDidUpdate() {
        const isLogin = !!(this.props.auth && this.props.auth.isLogin)
        if (isLogin && !this.state.me && !this.meLoading) {
            this.loadMe()
        }
    }

    public componentWillUnmount() {
        this.unmounted = true
        if (this.meRetryTimer !== null) {
            window.clearTimeout(this.meRetryTimer)
            this.meRetryTimer = null
        }
    }

    private loadMe = () => {
        if (this.meLoading) return
        const isLogin = !!(this.props.auth && this.props.auth.isLogin)
        if (!isLogin) return
        this.meLoading = true
        HokanApi.me()
            .then(x => {
                this.meLoading = false
                if (this.unmounted) return
                const u = x.data
                this.setState({ me: u })
                if (u.branch) {
                    this.loadAvatar();
                }
            })
            .catch(err => {
                this.meLoading = false
                console.log(err);
                if (this.unmounted) return
                if (this.meRetryTimer !== null) return
                this.meRetryTimer = window.setTimeout(() => {
                    this.meRetryTimer = null
                    if (this.unmounted) return
                    if (!this.state.me) {
                        this.loadMe()
                    }
                }, 1500)
            })
    }

    private loadAvatar() {
        const u = this.state.me;
        if (u && u.branch) {
            AvatarStore.getUrl(u.branch.company_id, u.id).then(url => {
                resolveAttachmentUrl(url).then(resolvedUrl => {
                    this.setState({ avatar_url: resolvedUrl })
                })
            }).catch(err => {

            })
        }
    }

    private doClose = () => {
        this.setState({ open: false })
    }

    private logout = () => {
        this.props.auth!.logout();
        this.doClose();
        this.props.history.push("/login", { logout: true })
    }

    private getUserName = () => {
        return this.state.me ? this.state.me.name : ""
    }

    private getBranchName = () => {
        return this.state.me && this.state.me.branch ? this.state.me.branch.name : ""
    }

    private setNotifyCount(c: number) {
        this.setState({ notifyCount: c })
    }

    private setAvatarImage(file: File) {
        const me = this.state.me
        if (me && me.branch && file) {
            ImageUtil.compress(file, 400).then(res => {
                if (me && me.branch) {
                    AvatarStore.put(me.branch.company_id, me.id, res).then(x => {
                        this.loadAvatar();
                    }).catch(err => {
                        console.log(err)
                    })
                }
            })
        }
    }

    public render() {
        const { classes, theme } = this.props;
        const { open, openPatient } = this.state;
        const iconHeight = "25px"
        const icons = this.props.loginMode ? [] : [
            //{ text: 'ホーム', icon: <Icons.Home />, link: "/home" },
            { text: '利用者', icon: <img src="/images/icons/基本_b.png" height="25px" />, link: "/patients" },
            { text: '書類', icon: <img src="/images/icons/書類B_b.png" height="25px" />, link: "/document" },
            { text: '自分', icon: <img src="/images/icons/自分B_b.png" height="25px" />, link: "/my" },
            { text: 'スコア', icon: <img src="/images/icons/スコア_b.png" height="25px" />, link: "/score" },
            { text: 'タスクリスト', icon: <img src="/images/icons/タスクリストB_b.png" height="25px" />, link: "/task" },
            { text: 'ガイドライン', icon: <img src="/images/icons/ガイドラインB_b.png" height="25px" />, link: "/guidline" },
            //{ text: '実績カレンダー', icon: <Icons.LibraryBooks />, link: "/jimu/jisseki_calendar" },
            //{ text: '出退勤管理', icon: <Icons.Settings />, link: "/work_record" },
            { text: '事故・苦情・災害', icon: <img src="/images/icons/インシデントB_b.png" height="25px" />, link: "/incident" },
            { text: '管理', icon: <img src="/images/icons/管理B_b.png" height="25px" />, link: "/manage" },
            //{ text: 'コンポーネント', icon: <Icons.Extension />, link: "/components" },
        ];

        return <div className={classes.root}>
            <CssBaseline key="baseline1" />
            <AppBar
                key="appbar"
                position="fixed"
                style={{
                    color: Colors.primaryColor,
                    backgroundColor: "white",
                    top: 'var(--urgent-banner-height, 0px)'
                }}
                className={classNames(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
            >
                <Toolbar disableGutters className={classes.toolBar}>
                    <IconButton
                        color="inherit"
                        aria-label="Open drawer"
                        onClick={this.handleDrawerOpen}
                        className={classNames(classes.menuButton, open && classes.hide)}
                    >
                        <Menu />
                    </IconButton>
                    <div className={classes.title}>
                        <SearchForm userName={this.getUserName()} history={this.props.history} classes={classes} />
                    </div>
                    <div className={classes.rightSpacer} />
                    <IconButton
                        color="inherit"
                        aria-label="Open drawer"
                        onClick={this.handlePatientOpen}
                        edge="end"
                        className={classNames(classes.patientButton, openPatient && classes.hide)}
                    >
                        <Badge badgeContent={this.state.notifyCount > 0 ? " " : 0 }
                            color={"secondary"}
                            classes={{ badge: classes.badge }}
                            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}>
                            <Group />
                        </Badge>
                    </IconButton>
                    {this.state.me && (
                        <React.Suspense fallback={null}>
                            <NotificationBell meId={this.state.me.id} />
                        </React.Suspense>
                    )}
                </Toolbar>
            </AppBar>
            <PatientNavigation loginMode={this.props.loginMode}
                open={this.state.openPatient}
                setOpen={(f) => this.setState({ openPatient: f })}
                setNotifyCount={(c) => this.setNotifyCount(c)} />
            <SwipeableDrawer
                key="drawer"
                className={classes.drawer}
                swipeAreaWidth={1}
                // variant="persistent"
                anchor="left"
                open={open}
                hysteresis={0.3}
                onClose={() => this.handleDrawerClose()}
                onOpen={() => {
                    this.handleDrawerOpen();
                }}
                classes={{
                    paper: classes.drawerPaper,
                }}
            >
                <div className={classes.drawerHeader}>
                    <div className={classes.drawerHeaderInfoBlock}>
                        <div className={classes.drawerHeaderInfoElement}>
                            <Tooltip title="変更" aria-label="change">
                                <Avatar
                                    onClick={() => {
                                        if (UADetector.isAndroid()) {
                                            this.setState({ avatarDialogOpen: true });
                                        } else {
                                            const el = document.getElementById("edit_own_avatar") as any;
                                            if (el) el.click();
                                        }
                                    }}
                                    alt="avatar" src={this.state.avatar_url == "none" ? undefined : this.state.avatar_url}
                                    className={classes.activity_face}
                                    style={{
                                        color: '#fff',
                                        backgroundColor: `#hsl(${this.state.me ? this.state.me.id * 130 : 0}, 50%, 80%)`,
                                    }}
                                >{this.state.avatar_url == "none" && this.state.me ? this.state.me.name.substr(0, 2) : null}</Avatar>
                            </Tooltip>
                            <div style={{ display: "inline-block", marginLeft: "10px", width: "75%" }}>
                                <Link style={{ textDecoration: "none", color: "white" }}
                                    to={`/manage/user/${this.state.me ? this.state.me.id : ""}`}
                                    onClick={() => { this.doClose() }}
                                >
                                    <p className={classes.drawerName}>{
                                        this.getUserName()
                                    }</p>
                                    <p className={classes.drawerOffice}>{
                                        this.getBranchName()
                                    }</p>
                                </Link>
                            </div>
                        </div>

                        <input type="file" id={`edit_own_avatar`} ref="file"
                            accept={ImageUtil.getAcceptAttribute()}
                            hidden={true}
                            onClick={(e) => { (e.target as HTMLInputElement).value = ''; }}
                            onChange={(e) => {
                                if (e.target.files && e.target.files.length > 0) {
                                    const validation = ImageUtil.validateImageFile(e.target.files[0]);
                                    if (!validation.valid) {
                                        AlertDialog.show(validation.errorMessage || '');
                                        return;
                                    }
                                    this.setAvatarImage(e.target.files[0])
                                }
                            }} />
                        <ImageSourceDialog
                            open={this.state.avatarDialogOpen}
                            onClose={() => this.setState({ avatarDialogOpen: false })}
                            onFileSelected={(file) => this.setAvatarImage(file)}
                        />
                    </div>
                    <div>
                        <IconButton onClick={this.handleDrawerClose} className={classes.drawerIcon} style={{ color: Colors.white, padding: "0px" }}>
                            {theme.direction === 'ltr' ? <ChevronLeft /> : <ChevronRight />}
                        </IconButton>
                    </div>
                </div>
                <Divider />
                <List disablePadding={true}>
                    {
                        icons.map((item, index) => {
                            return <div key={"header_list_" + index} className={classes.item}>
                                <Link to={item.link} className={classes.link} onClick={(e) => this.doClose()}>
                                    <ListItem button={true} key={item.text}>
                                        <ListItemIcon className={classes.drawerIcon}>
                                            {(item.icon as any) as JSX.Element}
                                        </ListItemIcon>
                                        <ListItemText disableTypography={true} primary={item.text} />
                                    </ListItem>
                                </Link>
                            </div>

                        })
                    }
                    {
                        this.props.loginMode ?
                            <Link to="/login" className={classes.link} onClick={(e) => this.doClose()}
                                style={{ backgroundColor: Colors.white, color: Colors.primaryColor }}>
                                <ListItem button={true} className={classes.item}>
                                    <ListItemIcon className={classes.drawerIcon}>
                                        <img src="/images/icons/ログアウトB_b.png" height="25px" />
                                    </ListItemIcon>
                                    <ListItemText disableTypography={true} onClick={(e) => this.logout()} primary="ログイン" />
                                </ListItem>
                            </Link>
                            :
                            <ListItem button={true} className={classes.item}
                                style={{ backgroundColor: Colors.white, color: Colors.primaryColor }}>
                                <ListItemIcon >
                                    <img src="/images/icons/ログアウトB_b.png" height="25px" />
                                </ListItemIcon>
                                <ListItemText disableTypography={true} onClick={(e) => this.logout()} primary="ログアウト" />
                            </ListItem>
                    }
                </List>
                <Divider style={{ marginTop: "auto" }} />
                <List className={classes.link} >
                    {
                        false ?
                            <Link to={"/inquiry"} className={classes.link} onClick={(e) => this.doClose()}>
                                <ListItem button={true}>
                                    <ListItemIcon className={classes.drawerIcon}>
                                        <HelpOutline />
                                    </ListItemIcon>
                                    <ListItemText disableTypography={true} primary="お問い合わせ" />
                                </ListItem>
                            </Link>
                            : null
                    }

                    <Link to={"/terms"} className={classes.link} style={{ backgroundColor: Colors.primaryColor, fontSize: "1rem", color: Colors.white }}>
                        <ListItem button={true}>
                            <ListItemIcon className={classes.drawerIcon}>
                                <img src="/images/icons/white_logo.png" height="25px" />
                            </ListItemIcon>
                            <ListItemText disableTypography={true} primary="お問い合わせ・利用規約" />
                        </ListItem>
                    </Link>
                </List>
            </SwipeableDrawer>
        </div>
    }
}

interface SearchOption {
    cat: string
    catName: string
    name: string
    id: number
    branchId?: number
    isLoadMore?: boolean
    type?: "patients" | "users" | "organizations"
}

interface CategoryPagination {
    page: number
    hasMore: boolean
}

interface SearchFormState {
    text: string
    open: boolean
    list: SearchOption[]
    loading: boolean
    lastQuery: string
    pagination: {
        patients: CategoryPagination
        users: CategoryPagination
        organizations: CategoryPagination
    }
}

// Debounce timer reference
let searchDebounceTimer: NodeJS.Timeout | null = null;

// Sort options by category order then catName for proper grouping
// Load More buttons go at the end of each main category (separate group)
const CAT_ORDER: { [key: string]: number } = { "利用者": 0, "スタッフ": 1, "関係機関": 2 };
const sortSearchOptions = (options: SearchOption[]): SearchOption[] => {
    return options.sort((a, b) => {
        const catA = CAT_ORDER[a.cat] !== undefined ? CAT_ORDER[a.cat] : 99;
        const catB = CAT_ORDER[b.cat] !== undefined ? CAT_ORDER[b.cat] : 99;
        const catDiff = catA - catB;
        if (catDiff !== 0) return catDiff;
        // Load More buttons go to end of their category
        if (a.isLoadMore && !b.isLoadMore) return 1;
        if (!a.isLoadMore && b.isLoadMore) return -1;
        // Regular items sorted by catName
        if (a.catName < b.catName) return -1;
        if (a.catName > b.catName) return 1;
        return 0;
    });
};

class SearchForm extends React.Component<
    { userName: string, history: any, classes: any },
    SearchFormState
> {
    constructor(props: any) {
        super(props)
        this.state = {
            text: "",
            open: false,
            list: [],
            loading: false,
            lastQuery: "",
            pagination: {
                patients: { page: 1, hasMore: false },
                users: { page: 1, hasMore: false },
                organizations: { page: 1, hasMore: false }
            }
        }
    }

    private clicked(option: SearchOption) {
        if (!option) return;

        // Handle "Load More" click - keep dropdown open
        if (option.isLoadMore && option.type) {
            this.loadMore(option.type);
            return;  // Don't close dropdown
        }

        // Regular option - close dropdown and navigate
        this.setState({ text: "", open: false, list: [] })
        if (option.cat == "利用者") {
            this.props.history.push(`/patients/${option.id}`);
        }
        else if (option.cat == "関係機関") {
            this.props.history.push(`/manage/organizations?name=${option.name}`);
        }
        else if (option.cat == "スタッフ") {
            this.props.history.push(`/manage/user?name=${option.name}&branch=${option.branchId}`);
        }
    }

    // Transform API response to SearchOption[] with Load More buttons
    private buildSearchOptions(
        response: GlobalSearchResponse,
        existingOptions: SearchOption[] = [],
        appendType?: "patients" | "users" | "organizations"
    ): { options: SearchOption[], pagination: SearchFormState["pagination"] } {
        const pagination = { ...this.state.pagination };

        // When appending to a specific type, we keep existing items and insert new items at correct position
        if (appendType) {
            // Find index of Load More button for this type
            const loadMoreIndex = existingOptions.findIndex(o => o.isLoadMore && o.type === appendType);

            // Build new items to insert
            const newItems: SearchOption[] = [];

            if (appendType === "patients" && response.patients && response.patients.data) {
                response.patients.data.forEach(x => {
                    const catName = "利用者(" + (x.branch_name || "") + ")";
                    newItems.push({ cat: "利用者", catName: catName, name: x.name, id: x.id });
                });
                pagination.patients = { page: response.patients.page, hasMore: response.patients.has_more };
                if (response.patients.has_more) {
                    newItems.push({ cat: "利用者", catName: "利用者 さらに読み込む", name: "さらに読み込む...", id: -1, isLoadMore: true, type: "patients" });
                }
            } else if (appendType === "users" && response.users && response.users.data) {
                response.users.data.forEach(x => {
                    const catName = "スタッフ(" + (x.branch_name || "") + ")";
                    newItems.push({ cat: "スタッフ", catName: catName, name: x.name, id: x.id, branchId: x.branch_id });
                });
                pagination.users = { page: response.users.page, hasMore: response.users.has_more };
                if (response.users.has_more) {
                    newItems.push({ cat: "スタッフ", catName: "スタッフ さらに読み込む", name: "さらに読み込む...", id: -2, isLoadMore: true, type: "users" });
                }
            } else if (appendType === "organizations" && response.organizations && response.organizations.data) {
                response.organizations.data.forEach(x => {
                    newItems.push({ cat: "関係機関", catName: "関係機関", name: x.name, id: x.id });
                });
                pagination.organizations = { page: response.organizations.page, hasMore: response.organizations.has_more };
                if (response.organizations.has_more) {
                    newItems.push({ cat: "関係機関", catName: "関係機関 さらに読み込む", name: "さらに読み込む...", id: -3, isLoadMore: true, type: "organizations" });
                }
            }

            // Insert new items at the position of the old Load More button (replacing it)
            let options: SearchOption[];
            if (loadMoreIndex >= 0) {
                options = [
                    ...existingOptions.slice(0, loadMoreIndex),
                    ...newItems,
                    ...existingOptions.slice(loadMoreIndex + 1)
                ];
            } else {
                // Fallback: append at end
                options = [...existingOptions, ...newItems];
            }

            return { options: sortSearchOptions(options), pagination };
        }

        // Full search (no appendType) - build everything fresh
        let options: SearchOption[] = [];

        // Patients
        if (response.patients && response.patients.data) {
            response.patients.data.forEach(x => {
                const catName = "利用者(" + (x.branch_name || "") + ")";
                options.push({ cat: "利用者", catName: catName, name: x.name, id: x.id });
            });
            pagination.patients = { page: response.patients.page, hasMore: response.patients.has_more };
            if (response.patients.has_more) {
                options.push({ cat: "利用者", catName: "利用者 さらに読み込む", name: "さらに読み込む...", id: -1, isLoadMore: true, type: "patients" });
            }
        }

        // Users
        if (response.users && response.users.data) {
            response.users.data.forEach(x => {
                const catName = "スタッフ(" + (x.branch_name || "") + ")";
                options.push({ cat: "スタッフ", catName: catName, name: x.name, id: x.id, branchId: x.branch_id });
            });
            pagination.users = { page: response.users.page, hasMore: response.users.has_more };
            if (response.users.has_more) {
                options.push({ cat: "スタッフ", catName: "スタッフ さらに読み込む", name: "さらに読み込む...", id: -2, isLoadMore: true, type: "users" });
            }
        }

        // Organizations
        if (response.organizations && response.organizations.data) {
            response.organizations.data.forEach(x => {
                options.push({ cat: "関係機関", catName: "関係機関", name: x.name, id: x.id });
            });
            pagination.organizations = { page: response.organizations.page, hasMore: response.organizations.has_more };
            if (response.organizations.has_more) {
                options.push({ cat: "関係機関", catName: "関係機関 さらに読み込む", name: "さらに読み込む...", id: -3, isLoadMore: true, type: "organizations" });
            }
        }

        return { options: sortSearchOptions(options), pagination };
    }

    // Search using global search API
    // When query is empty, loads all items (initial state)
    private async doSearch(query?: string) {
        this.setState({ loading: true });

        try {
            const q = (query && query.trim()) || undefined;
            const response = await globalSearch({ q });
            const { options, pagination } = this.buildSearchOptions(response.data);
            this.setState({ list: options, loading: false, lastQuery: q || "", pagination });
        } catch (e) {
            console.error("Search failed:", e);
            this.setState({ list: [], loading: false });
        }
    }

    // Load more items for a specific category
    private async loadMore(type: "patients" | "users" | "organizations") {
        const { text, pagination, list } = this.state;
        const currentPage = pagination[type] ? pagination[type].page : 1;
        const nextPage = currentPage + 1;

        this.setState({ loading: true });

        try {
            const q = (text && text.trim()) || undefined;
            const response = await globalSearch({ q: q, type: type, page: nextPage });
            const { options, pagination: newPagination } = this.buildSearchOptions(response.data, list, type);
            this.setState({ list: options, loading: false, pagination: newPagination });
        } catch (e) {
            console.error("Load more failed:", e);
            this.setState({ loading: false });
        }
    }

    private handleInputChange = (event: any, value: string) => {
        // Ignore if value is Load More text (clicked Load More option)
        if (value === "さらに読み込む...") {
            return;
        }

        this.setState({ text: value });

        // Clear previous debounce timer
        if (searchDebounceTimer) {
            clearTimeout(searchDebounceTimer);
        }

        // Set new debounce timer (300ms)
        searchDebounceTimer = setTimeout(() => {
            this.doSearch(value);
        }, 300);
    }

    componentWillUnmount() {
        // Clear debounce timer on unmount
        if (searchDebounceTimer) {
            clearTimeout(searchDebounceTimer);
        }
    }

    public render() {
        const isEmpty = this.state.open == false
        const { classes } = this.props;
        return [
            <Link key="headericon" to="/patients">
                <img src="/images/icons/monocolored_logo.png" height="20px"/>
            </Link>,
            isEmpty ?
                <div key="uname" style={{
                    display: "inline-flex",
                    verticalAlign: "middle",
                    marginLeft: "10px"
                }}>
                    {this.props.userName}
                </div> : null,
            <Autocomplete
                key="search-form"
                id="search-form"
                clearOnEscape={true}
                disableCloseOnSelect={true}
                open={this.state.open}
                options={this.state.list}
                size="small"
                style={{
                    display: "inline-flex",
                    marginLeft: isEmpty ? "10px" : "0px",
                    width: isEmpty ? 100 : 180
                }}
                classes={{
                    groupLabel: classes.autocomplete_group,
                    groupUl: classes.autocomplete_ul
                }}
                fullWidth={false}
                groupBy={(option) => option.catName}
                renderGroup={(params) => {
                    // Hide group label for Load More items
                    const isLoadMoreGroup = params.group.includes("さらに読み込む");
                    return (
                        <li key={params.key}>
                            {!isLoadMoreGroup && (
                                <div className={classes.autocomplete_group}>{params.group}</div>
                            )}
                            <ul className={classes.autocomplete_ul}>{params.children}</ul>
                        </li>
                    );
                }}
                onChange={(e, v) => { this.clicked(v as any) }}
                onOpen={() => { this.setState({ open: true, text: "" }); this.doSearch(); }}
                onClose={() => this.setState({ open: false, text: "", list: [] })}
                renderOption={(option: SearchOption, { selected }) => (
                    <div style={{
                        marginTop: "-5px",
                        marginBottom: "-5px",
                        fontSize: "smaller",
                        color: option.isLoadMore ? Colors.primaryColor : "inherit",
                        fontWeight: option.isLoadMore ? "bold" : "normal"
                    }}>
                        {option.name}
                    </div>
                )}
                inputValue={this.state.text}
                value={null}
                loading={this.state.loading}
                loadingText=""
                noOptionsText={this.state.text.length > 0 ? "なし" : "検索してください"}
                onInputChange={this.handleInputChange}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                    <div ref={params.InputProps.ref}>
                        <input
                            style={{
                                width: isEmpty ? 100 : 200,
                                height: 22,
                                padding: 0,
                                margin: 0,
                                boxSizing: 'border-box',
                                fontSize: 16,
                                lineHeight: '20px',
                                transform: 'scale(0.875)',
                                transformOrigin: 'left center',
                            }}
                            type="text"
                            placeholder="検索"
                            {...params.inputProps}
                        />
                    </div>
                )}
                filterOptions={(options) => options}
            />
        ]
    }
}
export default withPageProps(Styles.withStyles(styles, { withTheme: true })(HeaderNavigation));
